import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#ffc107",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M14 2.6v10.8a.6.6 0 0 1-.6.6H2.6a.6.6 0 0 1-.6-.6V2.6a.6.6 0 0 1 .6-.6h10.8a.6.6 0 0 1 .6.6"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#ffc107",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M5.333 4s-1.666 2 0 4c1.667 2 0 4 0 4M8 4S6.334 6 8 8c1.667 2 0 4 0 4M10.667 4s-1.667 2 0 4c1.666 2 0 4 0 4"
    }, null, -1)
  ]))]))
}
export default { render: render }